/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
// import "../../../css/Dashboard/home/Home.css";
import {
  messagesActionCreators,
  userDataActionCreators,
} from "../../../service/action-creators";
import { GetUserProfile } from "../../../service/action-creators/authAction";
import { GetNotifications } from "../../../service/action-creators/notificationAction";
import { GetCartProducts } from "../../../service/action-creators/userDataAction";
import Loader from "../../Loader";
import Modal from "../../Modal/Modal";
import RenderHome from "../home/RenderHome";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "./MessageAdmin.css";
import {
  Delete,
  Remove,
  Search,
  Add,
  Message,
  AccessTime,
  Person,
} from "@material-ui/icons";

function MessageAdmin() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    GetConversations,
    GetUsersForChat,
    MarkMessageAsRead,
    ResetMessagesResponse,
    addMessages,
    getMessages,
  } = bindActionCreators(messagesActionCreators, dispatch);

  const auth = useSelector((state) => state.auth);
  const chat = useSelector((state) => state.messages);

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState({});

  const { usersForChat, response, messages, isLoading } = chat;

  console.log("chat", chat);
  console.log("messages", messages);

  useEffect(() => {
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    dispatch(GetCartProducts());
    GetUsersForChat();
    // getMessages('authhere new');
    // GetConversations(auth?.user?._id);
  }, []);

  useEffect(() => {
    getMessages(auth?.user?._id);
    // GetConversations(auth?.user?._id);
  }, [auth?.user?._id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target.value });
  };

  const validateForm = () => {
    let err = {};

    if (formData.system_user === "" || !formData.system_user) {
      err.system_user = "Please choose department";
    }
    if (formData.message === "" || !formData.message) {
      err.message = "Message field is required";
    }

    // if (formData.subject === "" || !formData.subject) {
    //   err.subject = "Subject field is required";
    // }

    setFormError({ ...err });
    const keys = Object.keys(err);
    return Object.keys(err).length < 1;
    // return false
  };

  const handleSubmit = () => {
    let isValid = validateForm();
    if (isValid) {
      console.log(formData);
      const payload = {
        ...formData,
        user_id: auth?.user?._id,
        member_profile: auth?.user?.profile_image,
        reference: "",
      };
      addMessages(payload);
      setOpen(false);
    }
  };

  const handleDeleteDelete = () => {
    alert("delete");
  };

  useEffect(() => {
    if (response.state === "SUCCESS") {
      getMessages(auth?.user?._id);
      // toast.success(response?.message ?? "Notifications loaded");
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    } else if (response.state === "ERROR") {
      // toast.error(response?.message ?? "unable to get notification");
      setTimeout(() => {
        ResetMessagesResponse();
      }, 1500);
    }
  }, [response.state]);

  const device = () => {
    return window.innerWidth < 1080;
  };

  const [isMobile, setIsMobile] = useState(device);
  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(device);
    });
    return 0;
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <RenderHome>
          {isLoading && (
            <div className="fixed inset-0 bg-white bg-opacity-80 flex items-center justify-center z-50">
              <Loader />
            </div>
          )}

          {/* Header Section */}
          <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Messages</h1>
                <p className="text-sm text-gray-500 mt-1">
                  Manage your conversations with different departments
                </p>
              </div>
              <button
                onClick={() => setOpen(true)}
                className="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-700 text-white font-medium rounded-lg shadow-sm transition-colors duration-200"
              >
                <Add className="w-5 h-5 mr-2" />
                Start New Chat
              </button>
            </div>
          </div>

          {/* Search Section */}
          <div className="px-6 mb-6">
            <div className="relative max-w-md">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="search"
                name="searchProduct"
                placeholder="Search conversations..."
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                // onChange={handleSearch}
              />
            </div>
          </div>

          {/* Messages List */}
          <div className="px-6">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden p-4">
              {messages?.length > 0 ? (
                <div className="divide-y divide-gray-200">
                  {messages?.map((message, index) => {
                    let chatArr = message?.chat;
                    let last = chatArr?.at(-1);
                    let isUnread = !last?.member_read;

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          MarkMessageAsRead(message?._id, last?._id);
                          history.push({
                            pathname: "/message-detailed",
                            state: { chat_id: message?._id },
                          });
                        }}
                        className={`p-6 hover:bg-gray-50 cursor-pointer transition-colors duration-200 ${
                          isUnread
                            ? "bg-blue-50 border-l-4 border-l-blue-500"
                            : ""
                        }`}
                      >
                        <div className="flex items-start justify-between">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-3 mb-2">
                              <div className="flex-shrink-0">
                                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                                  <Message className="w-5 h-5 text-white" />
                                </div>
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2">
                                  <span
                                    className={`text-sm font-medium text-gray-900 ${
                                      isUnread ? "font-bold" : ""
                                    }`}
                                  >
                                    #{message?.reference}
                                  </span>
                                  {isUnread && (
                                    <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                      New
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center gap-2 mt-1">
                                  <Person className="w-4 h-4 text-gray-400" />
                                  <span className="text-sm text-gray-600">
                                    {message?.system_user}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div className="ml-13">
                              <h3
                                className={`text-base font-medium text-gray-900 mb-1 ${
                                  isUnread ? "font-bold" : ""
                                }`}
                              >
                                {message?.subject || "No Subject"}
                              </h3>
                              <p className="text-sm text-gray-600 line-clamp-2">
                                {last?.message || "No messages yet"}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center gap-2 ml-4">
                            <div className="flex items-center text-xs text-gray-500">
                              <AccessTime className="w-4 h-4 mr-1" />
                              {moment(message?.updated_at).format("MMM Do YY")}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="p-12 text-center">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Message className="w-8 h-8 text-gray-400" />
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    No messages yet
                  </h3>
                  <p className="text-gray-500 mb-4">
                    Start a conversation with a department to get help.
                  </p>
                  <button
                    onClick={() => setOpen(true)}
                    className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-colors duration-200"
                  >
                    <Add className="w-5 h-5 mr-2" />
                    Start Your First Chat
                  </button>
                </div>
              )}
            </div>
          </div>

          {/* Modern Modal */}
          {open && (
            <Modal
              title={"Start new conversation"}
              width={isMobile ? "85%" : "35%"}
              closeModal={setOpen}
            >
              <div className="p-6">
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Choose Department
                      <span className="text-red-500 ml-1">*</span>
                    </label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      name="system_user"
                      onChange={handleChange}
                    >
                      <option value="">Select a department</option>
                      <option value="Mart Officer">Mart Officer</option>
                      <option value="Loan Officer">Loan Officer</option>
                    </select>
                    {formError.system_user && (
                      <p className="mt-2 text-sm text-red-600">
                        {formError.system_user}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Message<span className="text-red-500 ml-1">*</span>
                    </label>
                    <textarea
                      name="message"
                      onChange={handleChange}
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                      placeholder="Write your message here..."
                    />
                    {formError.message && (
                      <p className="mt-2 text-sm text-red-600">
                        {formError.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-8 pt-6 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => setOpen(false)}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </Modal>
          )}
        </RenderHome>
        <ToastContainer autoClose={3000} />
      </div>
    </>
  );
}

export default MessageAdmin;
